import { mapGetters } from "vuex";
import BrandApi from "@/services/api/brandApi";
import algoliasearch from "algoliasearch/lite";

const BrandService = new BrandApi(),
  trimLimit = 400;

export default {
  props: {
    profile: Object,
    brandVanityUrlName: String,
    isPrivate: Boolean,
  },
  data() {
    return {
      searchIndex: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      descriptionExpanded: false,
      chatMe: null,
      chatOther: null,
      showChatButton: false,
      instagram_followers: null,
    };
  },
  mounted() {
    this.initChat();
  },
  computed: {
    brandBioTrimmed() {
      if (this.profile.bio.length > trimLimit) {
        return this.profile.bio.substring(0, trimLimit) + "...";
      }
      return this.profile.bio;
    },

    canBioExpand() {
      return this.profile.bio.length > trimLimit;
    },
    ...mapGetters({
      user: "userState",
    }),
    isMe: function () {
      return this.user && this.user.retailer_id && this.user.retailer_id === this.$route.params.id;
    },
  },
  methods: {
    initChat,
  },
};

async function initChat() {
  if (this.user && this.user.brand_id) {
    this.searchIndex = this.algoliaClient.initIndex(this.$env.getOrigin() + "_invoices_status_asc");
    const { data } = await BrandService.getBrandMe(),
      response = await this.searchIndex.search({
        facets: "*,brand_name",
        facetFilters: [`brand_name:${data.brand_name}`],
      });
    if (response.nbHits !== 0) {
      this.chatMe = {
        fullName: `${data.first_name} from ${data.brand_name}`,
        role: "BRAND",
        userId: this.user.brand_id,
        email: data.email,
      };
      this.chatOther = {
        storeName: this.profile.store_name,
        firstName: this.profile.first_name,
        email: this.profile.email,
        userId: this.profile.id,
        role: "RETAILER",
      };
      this.showChatButton = true;
    }
  }
}
